import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ButtonSelect, ButtonTextSelectControl } from '../../../Select'
import { PROFILE_CONTACTS_WIDGET_QA_NAME } from '../ProfileContactsWidget.constants'

import { DROPDOWN_OFFSET_CONFIG } from './ProfileContactsWidgetButtonSelect.constants'
import {
  getContactsButtonSelectOptions,
  getTooltip,
} from './ProfileContactsWidgetButtonSelect.utils'

import * as styles from './ProfileContactsWidgetButtonSelect.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function ProfileContactsWidgetButtonSelect({
  addTypes,
  buttonSelectProps,
  className = styles.button,
  disabled,
  existingTypes,
  isLimitReached,
  offsetConfig = DROPDOWN_OFFSET_CONFIG,
  textKey = 'ProfileContactsWidget.AddNewKey',
  onSelectItem,
}) {
  const { t } = useTranslation()

  const options = getContactsButtonSelectOptions({ addTypes, existingTypes, t })

  // With every type unique and present there is nothing left to add.
  return options.length === 0 ? null : (
    <ButtonSelect
      {...buttonSelectProps}
      Control={ButtonTextSelectControl}
      controlProps={{
        ArrowIcon: null,
        buttonProps: {
          beforeIconProps: { Icon: PlusIcon },
          className,
          disabled,
          isGrey: false,
          qaName: PROFILE_CONTACTS_WIDGET_QA_NAME.addButton,
          text: t(textKey),
          tooltipPlacement: FLOATING_ELEMENT_PLACEMENT.top,
        },
        getTooltip: disabled
          ? () => getTooltip({ isLimitReached, t })
          : undefined,
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
        maxWidthByRef: false,
        offsetConfig,
      }}
      dropdownProps={{
        className: styles.dropdown,
      }}
      listProps={{
        itemProps: {
          contentProps: {
            infoProps: {
              contentTextProps: {
                textProps: { isSecondary: true },
              },
            },
          },
        },
      }}
      options={options}
      onSelectItem={onSelectItem}
    />
  )
}

export default ProfileContactsWidgetButtonSelect
